import React from "react";
import { useSelector } from "react-redux";

import { useDropdownTemplateAvailability } from "@/Hooks/useGetTemplates";

import EditIcon from "../../assets/edit.svg";
import "./CasePanelHeader.css";

const formatPhoneNumber = (number) => {
  if (!number) return null;
  const cleanedNumber = number.replace(/\D/g, "");

  const areaCode = cleanedNumber.slice(0, 3);
  const firstPart = cleanedNumber.slice(3, 6);
  const secondPart = cleanedNumber.slice(6);
  return `(${areaCode}) ${firstPart}-${secondPart}`;
};
const ContactPanelCasePage = ({
  id,
  panel_name,
  // name,
  address1,
  address2,
  city,
  state,
  zip_code,
  phone_number,
  ext = "",

  pageName = "",
  onSelectObject,
  buttonData,
  className = "",
  fax_number,
  // dynamic_label,
  genrate_doc_address,
  templateDropdownId,
  templatePageId,
  nickName = "",
  isCaseHomeOffice = false,
}) => {
  const currentPageId = useSelector((state) => state.page_id_click_record.page_id_click_record);
  const hasTemplateButton = buttonData?.some((button) =>
    /^(letter|generate document)$/i.test(button?.buttonText ?? "")
  );
  const { templatesAvailable } = useDropdownTemplateAvailability(
    templatePageId ?? currentPageId,
    templateDropdownId,
    { enabled: hasTemplateButton }
  );
  const isTemplateButtonDisabled = (button) =>
    button.disabled ||
    (/^(letter|generate document)$/i.test(button?.buttonText ?? "") && !templatesAvailable);
  const PanelHeader = isCaseHomeOffice ? "button" : "p";
  return (
    <>
      <div
        className={`info-div ${className} ${isCaseHomeOffice ? "case-panel-edit-panel" : ""}`}
        style={{
          width: pageName !== "" && pageName?.startsWith("litigation") ? "auto" : "255px",
          minWidth: pageName !== "" && pageName?.startsWith("litigation") ? "255px" : "",
        }}
      >
        <div
          className=""
          style={{
            cursor: "pointer",
          }}
        >
          <div onClick={onSelectObject}>
            <PanelHeader
              className={`menu-bar-style columnsTitle text-center text-primary font-weight-semibold text-uppercase d-flex align-items-center justify-content-center position-relative ${isCaseHomeOffice ? "case-panel-action-header" : ""}`}
              type={isCaseHomeOffice ? "button" : undefined}
              aria-label={isCaseHomeOffice ? "Edit Case Home Office" : undefined}
              onClick={
                isCaseHomeOffice
                  ? (event) => {
                      event.stopPropagation();
                      onSelectObject?.();
                    }
                  : undefined
              }
              style={{
                // backgroundColor: "var(--primary-15)",
                height: "25px",
                whiteSpace: "nowrap",
              }}
            >
              {panel_name}
              {isCaseHomeOffice && (
                <span className="case-panel-header-icon" aria-hidden="true">
                  <img src={EditIcon} width="15" height="15" alt="" />
                </span>
              )}
            </PanelHeader>

            <>
              {/* {name?.trim() ? (
                <p
                  style={{ backgroundColor: "var(--primary-2)" }}
                  className="font-weight-semibold text-capitalize bg-speciality-2 p-r-5 p-l-5 text-truncated"
                >
                  {name}
                </p>
              ) : (
                <p
                  className="font-weight-semibold text-capitalize bg-speciality-2 p-r-5 p-l-5"
                  style={{
                    backgroundColor: "var(--primary-2)",
                    color: "var(--primary-25)",
                  }}
                >
                  {dynamic_label?.trim() ? dynamic_label : "Full Name"}
                </p>
              )} */}
              {
                <p
                  className="font-weight-semibold text-capitalize bg-speciality-2 p-r-5 p-l-5"
                  style={{
                    backgroundColor: "var(--primary-2)",
                    color: nickName?.trim() ? "" : "var(--primary-25)",
                  }}
                >
                  {nickName?.trim() ? nickName : "Office NickName"}
                </p>
              }
              <div>
                <p
                  className="inline-row-h-21 text-capitalize p-r-5 bg-speciality-4 p-l-5"
                  style={{
                    backgroundColor: "var(--primary-4)",
                    overflow: "hidden",
                    display: "-webkit-box",
                    WebkitLineClamp: 1,
                    WebkitBoxOrient: "vertical",
                  }}
                >
                  {address1 || address2 ? (
                    <p className="font-weight-semibold ">
                      {address1 && <span>{address1}</span>}
                      {address1 && address2 && <span>, </span>}{" "}
                      {/* Render comma only if both addresses exist */}
                      {address2 && <span>{address2}</span>}
                    </p>
                  ) : (
                    <span
                      className="font-weight-semibold text-capitalize"
                      style={{
                        backgroundColor: "var(--primary-4)",
                        color: "var(--primary-25)",
                      }}
                    >
                      Address
                    </span>
                  )}
                </p>

                <p
                  className="inline-row-h-21 text-capitalize bg-speciality-2 p-r-5 p-l-5"
                  style={{
                    backgroundColor: "var(--primary-2)",
                    overflow: "hidden",
                    display: "-webkit-box",
                    WebkitLineClamp: 1,
                    WebkitBoxOrient: "vertical",
                  }}
                >
                  {city ? (
                    <span className="font-weight-semibold">{city},</span>
                  ) : (
                    <span className="font-weight-semibold" style={{ color: "var(--primary-25)" }}>
                      city,
                    </span>
                  )}{" "}
                  {state ? (
                    <span className="font-weight-semibold">{state}</span>
                  ) : (
                    <span className="font-weight-semibold" style={{ color: "var(--primary-25)" }}>
                      state
                    </span>
                  )}{" "}
                  {zip_code ? (
                    <span className="font-weight-semibold">{zip_code}</span>
                  ) : (
                    <span
                      className="font-weight-semibold "
                      style={{
                        color: "var(--primary-25)",
                        textTransform: "uppercase",
                      }}
                    >
                      zip
                    </span>
                  )}
                </p>
              </div>
              <div>
                <p
                  className="inline-row-h-21 height-21 p-r-5 p-l-5 bg-speciality-4"
                  style={{
                    backgroundColor: "var(--primary-4)",
                  }}
                >
                  {phone_number ? (
                    <span className="font-weight-semibold">{formatPhoneNumber(phone_number)}</span>
                  ) : (
                    <span className="font-weight-semibold" style={{ color: "var(--primary-25)" }}>
                      (###) ###-####
                    </span>
                  )}
                  {ext && (
                    <>
                      <small
                        className="ms-1 font-weight-semibold"
                        style={{ color: "var(--primary-25)" }}
                      >
                        ext
                      </small>{" "}
                      <span className="font-weight-semibold">{ext}</span>
                    </>
                  )}
                </p>
              </div>
              <div>
                <p
                  className="inline-row-h-21 height-21 p-r-5 p-l-5 bg-speciality-4"
                  style={{
                    backgroundColor: "var(--primary-2)",
                  }}
                >
                  {fax_number ? (
                    <span className="font-weight-semibold">{formatPhoneNumber(fax_number)}</span>
                  ) : (
                    <span className="font-weight-semibold" style={{ color: "var(--primary-25)" }}>
                      (###) ###-####
                    </span>
                  )}

                  <>
                    <small
                      className="ms-1 font-weight-semibold"
                      style={{ color: "var(--primary-25)" }}
                    >
                      fax
                    </small>{" "}
                  </>
                </p>
              </div>
              <div>
                <p
                  className="inline-row-h-21 height-21 p-r-5 p-l-5 bg-speciality-4"
                  style={{
                    backgroundColor: "var(--primary-4)",
                  }}
                >
                  {/*  */}
                </p>
              </div>
            </>
          </div>
        </div>
        {buttonData?.length > 0 && (
          <div className="mt-auto" style={{ display: "flex", gap: "5px", marginTop: "5px" }}>
            {buttonData?.map((button, index) => (
              <button
                type="button"
                id={index}
                style={{
                  minWidth: "81px",
                  backgroundColor: "var(--primary-10)",
                  borderColor: "var(--primary)",
                  color: isTemplateButtonDisabled(button) ? "var(--primary-25)" : "var(--primary)",
                  ...button.style,
                }}
                className={`btn btn-hover-contact-panel-row font-weight-semibold text-lg height-25 rounded-0 d-flex align-items-center justify-content-center ${button.className}`}
                disabled={isTemplateButtonDisabled(button)}
                onClick={() => button.onClick(id, genrate_doc_address)}
              >
                {button.iconClassName && <i className={`${button.iconClassName} me-1`} />}
                {button.imgSrc && (
                  <img className={button.imgClassName} src={button.imgSrc} alt="icon" />
                )}
                {button.buttonText}
              </button>
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default React.memo(ContactPanelCasePage);
